import { render, staticRenderFns } from "./DetailModify.vue?vue&type=template&id=34bcdf74&scoped=true&"
import script from "./DetailModify.vue?vue&type=script&lang=js&"
export * from "./DetailModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bcdf74",
  null
  
)

export default component.exports